export enum OAuthProviderEnum {
	Google = 'google',
}
